import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'

import Header from './IssueManagementHeader'
import ListView from './IssueManagementListView'
import Footer from './IssueManagementFooter'
import ReportModal from './IssueManagementReportModal'
import ResponseModal from './IssueManagementResponseModal'

import { ACCOUNT, MODAL, BOOKING } from '../../../../reduxs'
import apiService from '../../../../reduxs/apiService'
import { ISSUE, ISSUE_STATUS } from '../../../../helpers/constants'

import Style from './style'

export class IssueManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpenReportModal: false,
      isOpenResponseModal: false,
      isFocusDropdown: false,
      isErrorDropdown: false,
      isLoading: false,
      isErrorCreate: false,
      orders: [],
      issues: [],
      selectedDropdown: null,
      searchDropdown: '',
      issueDetail: '',
      images: [],
    }
  }

  componentDidMount() {
    this.getIssues()
  }

  getIssues = async () => {
    const date = new Date () /* TODO: change later, when merging with an active meeting. this mock */
    const params = {
      companyId: 2, /* TODO: change later, this mock */
      startDatetime: `${moment(date).format('YYYY-MM-DD')} 00:00:00`,
      endDatetime: `${moment(date).format('YYYY-MM-DD')} 23:59:59`,
      limit: 30, /* TODO: change later, when lazy load is included */
      page: 1, /* TODO: change later, when lazy load is included */
      sorts: JSON.stringify({ type: 'DESC', column: 'createdAt' }),
    }
    this.setState({ isLoading: true })

    const res = await apiService.get('rest/v2/issue', params)

    try {
      if (res.status && res.data.list) {
        this.setState({ issues: res.data.list })
      }
    } catch (error) {
      console.error('Error get orders for issue report modal : ', error);
    } finally {
      this.setState({ isLoading: false })
    }
  }

  getOrders = async (itemName) => {
    const params = {
      companyId: 2, /* TODO: change later, this mock */
      type: [3], // Facility
      status: [0, 1, 2], // from api phase 1
      ordering: 'itemName ASC',
      ...itemName && { itemName },
    }
    this.setState({ isLoading: true })

    const res = await apiService.get('rest/v1/getlist_catering2', params)

    try {
      if (res.status && res.data.list) {
        this.setState({
          orders: res.data.list
            // status active and is used
            .filter(({ status, isUsed }) => status === 0 && isUsed === 1)
            .map(({ itemName, itemId }) => {
              return {
                itemId,
                name: itemName,
              }
            }
          )
        })
      }
      
    } catch (error) {
      console.error('Error get orders for issue report modal : ', error);
    } finally {
      this.setState({ isLoading: false })
    }
  }

  onClearCreateIssueForm = () => {
    this.setState({
      isOpenReportModal: false,
      isLoading: false,
      orders: [],
      images: [],
      issueDetail: '',
    })

    this.onClearSelectedDropdown()
  }

  onCreateIssue = () => {
    const { selectedDropdown, issueDetail, images } = this.state
    const { roomId, createIssue } = this.props

    this.setState({ isLoading: true })

    if (selectedDropdown) {
      const params = {
        roomId,
        itemId: selectedDropdown.itemId,
        images: images.map(({ file }) => file),
        detail: issueDetail,
        status: ISSUE_STATUS.WAITING, // api require
      }

      createIssue(params, async (res) => {
        if (res.status) {
          await this.onClearCreateIssueForm()

          this.setState({
            isOpenResponseModal: true,
            isErrorCreate: false,
          })
        } else {
          await this.onClearCreateIssueForm()

          this.setState({
            isOpenResponseModal: true,
            isErrorCreate: true,
          })
        }
      })
    } else {
      this.setState({
        isErrorDropdown: true,
        isLoading: false,
      })
    }
  }

  onOpenReportModal = (isOpenReportModal) => {
    this.setState({ isOpenReportModal })
  }

  onOpenResponseModal = (isOpenResponseModal) => {
    this.setState({ isOpenResponseModal })
  }

  onBlurDropdown = () => {
    setTimeout(() => {
      this.setState((prevState) => {
        return {
          isFocusDropdown: !prevState.isFocusDropdown,
        }
      })
    }, 200)
  }

  onFocusDropdown = async () => {
    this.setState({
      isFocusDropdown: true,
      isErrorDropdown: false,
    })

    await this.getOrders()
  }

  onSelectedDropdown = (selectedDropdown) => {
    this.setState({
      selectedDropdown,
      searchDropdown: selectedDropdown.name,
    })
  }

  onClearSelectedDropdown = () => {
    this.setState({
      searchDropdown: '',
      selectedDropdown: null,
    })
  }

  onChangeSearchDropdown = (e) => {
    this.setState({
      searchDropdown: e.target.value,
      selectedDropdown: null,
    }, () => {
      this.getOrders(this.state.searchDropdown)
    })
  }

  onChangeIssueDetail = (e) => {
    this.setState({ issueDetail: e.target.value })
  }

  onUploadImage = (e) => { // from phase 1
    const { language } = this.props
    const { images } = this.state
    const fileList = e.target.files
    const listFail = []
  
    if (e && fileList.length > 0) {
      const updatedImages = [...images]
  
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        const limit = 2145728
  
        if (file.size > limit) {
          listFail.push(file)
        } else {
          this.readAndAddImage(file, updatedImages);
        }
      }

      console.log(updatedImages)
  
      if (listFail.length > 0) {
        this.displayError(
          `${listFail.map((file, i) => (i === 0 ? '' : ' ') + file.name).join(' ')} ${ISSUE.LIMIT_FILE[language]}`
        )
      }
    }
  }
  
  readAndAddImage = (file, updatedImages) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onloadend = (event) => {
      const imageData = event.target.result
  
      updatedImages.push({
        data: imageData,
        file: file,
        id: event.timeStamp,
      })
  
      this.setState({
        images: updatedImages,
      })
    }
  }

  onDeleteImage = (id) => {
    const { images } = this.state

    this.setState({
      images: images.filter((image) => image.id !== id)
    })
  }

  onCloseReportModal = () => {
    this.onOpenReportModal(false)
    this.onClearCreateIssueForm()
  }

  onCloseResponseModal = () => {
    this.onOpenResponseModal(false)
    this.setState({ isErrorCreate: false })
    this.getIssues()
  }

  render() {
    const {
      isOpenReportModal,
      isOpenResponseModal,
      isFocusDropdown,
      isErrorDropdown,
      isLoading,
      isErrorCreate,
      orders,
      issues,
      searchDropdown,
      selectedDropdown,
      issueDetail,
      images,
    } = this.state
    const { language, colorTheme } = this.props

    return (
      <Style>
        <Header language={language} />

        <ListView
          language={language}
          issues={issues}
          isLoading={isLoading}
          colorTheme={colorTheme}
        />

        <Footer
          language={language}
          colorTheme={colorTheme}
          onOpenReportModal={this.onOpenReportModal}
        />

        <ReportModal
          isVisible={isOpenReportModal}
          isOpenDropdown={isFocusDropdown}
          isFocusDropdown={isFocusDropdown}
          isErrorDropdown={isErrorDropdown}
          language={language}
          colorTheme={colorTheme}
          orders={orders}
          searchDropdown={searchDropdown}
          selectedDropdown={selectedDropdown}
          issueDetail={issueDetail}
          images={images}
          getOrders={this.getOrders}
          onClose={this.onCloseReportModal}
          onBlurDropdown={this.onBlurDropdown}
          onFocusDropdown={this.onFocusDropdown}
          onSelectedDropdown={this.onSelectedDropdown}
          onClearSelectedDropdown={this.onClearSelectedDropdown}
          onChangeSearchDropdown={this.onChangeSearchDropdown}
          onChangeIssueDetail={this.onChangeIssueDetail}
          onCreateIssue={this.onCreateIssue}
          onUploadImage={this.onUploadImage}
          onDeleteImage={this.onDeleteImage}
        />

        <ResponseModal
          isVisible={isOpenResponseModal}
          isError={isErrorCreate}
          colorTheme={colorTheme}
          language={language}
          onClose={this.onCloseResponseModal}
        />
      </Style>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    createIssue: (param, func) => dispatch(BOOKING.action.createIssue(param, func)),
  }
}

export const mapStateToProps = ({ accountReducer }) => {
  return {
    language: accountReducer.language,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueManagement)
